var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61138 6.87353L0.160979 2.4231C-0.0536598 2.20846 -0.0536598 1.86048 0.160979 1.64586L0.680047 1.12679C0.89432 0.912522 1.24159 0.912109 1.45637 1.12588L5.00001 4.65292L8.54363 1.12588C8.75841 0.912109 9.10568 0.912522 9.31995 1.12679L9.83902 1.64586C10.0537 1.8605 10.0537 2.20849 9.83902 2.4231L5.38864 6.87353C5.174 7.08814 4.82602 7.08814 4.61138 6.87353Z",
    fill: "#00ADC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownHover);
export default __webpack_public_path__ + "static/media/arrow-down-hover.a1fbf044158f3efb6e27814210bf7aaa.svg";
export { ForwardRef as ReactComponent };